export const environment = {
  production: false,
  BB_SAMPLE_PROCESSING_API:"https://qa.apigatewayd.eurofinsgenomics.eu/qa-microarray-sampleprocessing/",
  BB_MA_LOGFILE_FUNC_APP_API: "https://qa.apigatewayd.eurofinsgenomics.eu/qa-microarray-logfilefuncapp/",
  BB_MA_DELIVERY_API:"https://qa.apigatewayd.eurofinsgenomics.eu/qa-microarray-delivery/",
  BB_RESULT_EVALUATION_URL: "https://qa.apigatewayd.eurofinsgenomics.eu/qa-microarray-result-evaluation/",
  BB_MDMSERVICE_URL: "https://qa.apigatewayd.eurofinsgenomics.eu/qa-microarray-mdm/",
  BB_APIGATEWAY_SERVICE_URL: "https://qa.apigatewayd.eurofinsgenomics.eu/qa-bbgateway/",
  BB_NGS_RUN_PLANNING_URL: "https://qa.apigatewayd.eurofinsgenomics.eu/qa-microarray-ngs-run-planning/",
  BB_APG_SAMPLE_PROCESSING_URL: "https://qa.apigatewayd.eurofinsgenomics.eu/qa-microarray-ngs-samples/",
  BB_STORAGE_URL: "https://qa.apigatewayd.eurofinsgenomics.eu/qa-microarray-storage/",
  AZURE_AUTHORIZATION_URL: "https://login.microsoftonline.com/1fbb4ba6-ea05-4146-a51e-8eab1e5605f0/oauth2/v2.0/authorize",
  AZURE_TOKEN_URL: "https://login.microsoftonline.com/1fbb4ba6-ea05-4146-a51e-8eab1e5605f0/oauth2/v2.0/token",
  AZURE_LOGOUT_URL: "https://login.microsoftonline.com/1fbb4ba6-ea05-4146-a51e-8eab1e5605f0/oauth2/v2.0/logout",
  AZURE_TENANT_ID: "1fbb4ba6-ea05-4146-a51e-8eab1e5605f0",
  AZURE_BBUI_CLIENT_ID: "e467e399-5e32-4d5b-a93f-f97069136158",
  AZURE_BBUI_REDIRECT_URL_AFTER_LOGIN: "https://array-qa.eurofinsgenomics.eu/",
  AZURE_MDM_GROUP_ID: 'MicroArrayAdmin',
  AZURE_MDM_DK_GROUP_ID: 'DKMicroarrayAdmin',
  AZURE_USER_GROUP_CLAIM : 'MicroArrayUser',
  AZURE_USER_DK_GROUP_CLAIM : 'DKMicroarrayUser',
  AZURE_SUPER_USER_GROUP_CLAIM: 'MicroArraySuperUser',
  AZURE_SUPER_USER_DK_GROUP_CLAIM: 'DKMicroarraySuperUser',
  AZURE_MDM_DK_DTC_POPGEN_GROUP_ID: 'DK_DTC_POPGEN_Admin',
  AZURE_MDM_US_EBDI_GROUP_ID: 'US_EBDI_Admin',
  AZURE_MDM_DE_FOOD_ENVIRONMENT_GROUP_ID: 'DE_FOOD_ENVIRONMENT_Admin',
  AZURE_USER_DK_DTC_POPGEN_GROUP_CLAIM : 'DK_DTC_POPGEN_User',
  AZURE_USER_US_EBDI_GROUP_CLAIM : 'US_EBDI_User',
  AZURE_USER_DE_FOOD_ENVIRONMENT_GROUP_CLAIM : 'DE_FOOD_ENVIRONMENT_User',
  AZURE_SUPER_USER_DK_DTC_POPGEN_GROUP_CLAIM: 'DK_DTC_POPGEN_SuperUser',
  AZURE_SUPER_USER_US_EBDI_GROUP_CLAIM: 'US_EBDI_SuperUser',
  AZURE_SUPER_USER_DE_FOOD_ENVIRONMENT_GROUP_CLAIM: 'DE_FOOD_ENVIRONMENT_SuperUser',
  AZURE_CONFIG_USER_CLAIM: 'MicroArrayConfigUser',
  AZURE_AUTHORIZATION_SCOPE: "api://95cd4e82-b3a4-4ac1-bff9-d959076f5573/bbmicroarray.access",//"openid profile User.Read email api://bdc9f432-4fbe-4ea7-b5db-1a272d6c7c9b/bb.ui.access",
  AZURE_LOGIN_NEEDED: true,
  AZURE_APPINSIGHTS_INSTRUMENTATIONKEY: "a3495082-b6aa-45b7-8945-9fa6e24999f9",
  //This is the timeout used by frontEnd services.This is in milli seconds.
  defaultTimeout:11000,
  GATC_NGLIMS_SERVICE_URL : "",
  ZIATH_SCAN_URL : "https://test-apigateway.eurofinsgenomics.com/uat-bbprint/ziath/scan"
};
